import { render, staticRenderFns } from "./Consultations.vue?vue&type=template&id=09947d82&"
import script from "./Consultations.vue?vue&type=script&lang=js&"
export * from "./Consultations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09947d82')) {
      api.createRecord('09947d82', component.options)
    } else {
      api.reload('09947d82', component.options)
    }
    module.hot.accept("./Consultations.vue?vue&type=template&id=09947d82&", function () {
      api.rerender('09947d82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/pacs008/SDD/Consultations.vue"
export default component.exports